export function getLastResponseExtensionData(responses) {
    if (responses.length) {
        return responses[responses.length - 1].extensionData;
    }
    return undefined;
}
